import { CircularProgress } from '@mui/material'

const defaultProps = {}
const propTypes = {}

export const Loading = props => {
  return <CircularProgress {...props} />
}

Loading.defaultProps = defaultProps
Loading.propTypes = propTypes

export default Loading
